import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from 'react';
import { VIEW_MODE } from './ChatWindow';

export const SIDE_PANEL_WIDTH = 440;

const ChatbotContext = createContext(null);

export function ChatbotProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [viewMode, setViewMode] = useState(VIEW_MODE.POPUP);

  const open = useCallback(() => {
    setViewMode(VIEW_MODE.POPUP);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  const changeViewMode = useCallback(mode => setViewMode(mode), []);

  // Only the push-based SIDE mode shifts page content; SIDE_OVERLAP floats over it
  const isSidePanelOpen = isOpen && viewMode === VIEW_MODE.SIDE;

  const value = useMemo(
    () => ({ isOpen, open, close, viewMode, changeViewMode, isSidePanelOpen }),
    [isOpen, open, close, viewMode, changeViewMode, isSidePanelOpen],
  );

  return (
    <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>
  );
}

export function useChatbotPanel() {
  return useContext(ChatbotContext);
}
